import React, { memo } from 'react';

import classes from './CloseButton.module.scss';

import { CloseButtonIcon } from '../../../';

const CloseButton = ({ onClick }) => {
  return (
    <div className={classes.ButtonContainer}>
      <button
      type="button"
      onClick={onClick} className={classes.CloseButton}>
        <CloseButtonIcon className={classes.Icon} />
      </button>
    </div>
  );
};

export default memo(CloseButton);
